import { Component, ViewEncapsulation, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { IPortfolioDetail } from '@irb/irb-editors/irb-editors.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-portfolio-created-dialog',
  templateUrl: './portfolio-created-dialog.component.html',
  styleUrls: ['./portfolio-created-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PortfolioCreatedDialogComponent implements OnInit {
  portfolioName: string;
  portfolioDetail: IPortfolioDetail;

  constructor(
    public dialogRef: MatDialogRef<PortfolioCreatedDialogComponent>,
    public as: AppService,
    private ats: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) { }

  ngOnInit() {
    this.portfolioName = this.mdd.portfolioName || "Untitled";
    this.portfolioDetail = this.mdd.portfolioDetail;
  }

  close() {
    this.dialogRef.close();
  }

  showPortfolioDetail() {
    this.ats.trackClickEvent("lc_newport_gotoport");
    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: this.portfolioDetail});
    this.dialogRef.close();
  }
}
